exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Referals{width:100%}.Referals .block-ref{display:flex;flex-direction:column;margin-bottom:30px}.Referals .block-ref input{border-color:#00adff!important;border-radius:10px;height:34px;padding:6px 12px;width:50%;font-size:14px;line-height:1.42857143;color:#555;background-color:#fff}.Referals .block-ref button{margin-left:15px;height:34px;color:#fff;background:#00adff;width:34px;border-radius:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/AdminPanel/Referals/style.scss
// module id = 5162
// module chunks = 0